import { Dashboard } from "../pages/Dashboard";
import { UserManagement, UserDetails } from "../pages/UserManagement";

import { Account } from "../pages/Account";
import { APP_ROUTES } from "../helpers/routeHelpers";
import { Roles } from "../constants";
import {
    AudioContentManagement,
    AudioSeries,
    AudioShares,
    AudioSoundscapes,
    AudioSingle,
    AddAudio,
    UpdateAudio,
    AudioSingleDetail,
    OnboardingDetail,
    Onboarding,
    AddOnboarding,
    UpdateOnboarding
} from "../pages/AudioContentManagement";
import { AddGoal, GoalDetails, GoalManagement, UpdateGoal } from "../pages/GoalManagement";
import {
    AddNotification,
    NotificatioDetail,
    NotificationManagement,
    NotificatioUpdate
} from "../pages/NotificationManagement";
import {
    AddAuthor,
    AddNarrator,
    AuthorAndNarratorManagement,
    AuthorDetails,
    NarratorDetails,
    UpdateNarrator,
    UpdateAuthor
} from "../pages/AuthorAndNarratorManagement";

let { Admin } = Roles;

const authProtectedRoutes = [
    // Dashboard
    {
        path: APP_ROUTES.DASHBOARD,
        component: Dashboard,
        permissions: [Admin],
        exact: true
    },
    // User Management

    {
        path: APP_ROUTES.USER_MANAGEMENT,
        component: UserManagement,
        permissions: [Admin],
        exact: true
    },

    {
        path: APP_ROUTES.USER_MANAGEMENT_DETAILS,
        component: UserDetails,
        permissions: [Admin],
        exact: false
    },

    //Audio Content Management
    {
        path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT,
        component: AudioContentManagement,
        permissions: [Admin],
        exact: false
    },
    {
        path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SINGLES,
        component: AudioSingle,
        permissions: [Admin],
        exact: true
    },
    {
        path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SINGLES_ADD,
        component: AddAudio,
        permissions: [Admin],
        exact: true
    },
    {
        path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SINGLES_DETAILS,
        component: AudioSingleDetail,
        permissions: [Admin],
        exact: false
    },
    {
        path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SINGLES_UPDATE,
        component: UpdateAudio,
        permissions: [Admin],
        exact: false
    },

    {
        path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SERIES,
        component: AudioSeries,
        permissions: [Admin],
        exact: true
    },
    {
        path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES,
        component: AudioSoundscapes,
        permissions: [Admin],
        exact: true
    },
    {
        path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SHARES,
        component: AudioShares,
        permissions: [Admin],
        exact: true
    },
    {
        path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_ONBOARDING,
        component: Onboarding,
        permissions: [Admin],
        exact: true
    },
    {
        path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_ONBOARDING_ADD,
        component: AddOnboarding,
        permissions: [Admin],
        exact: true
    },
    {
        path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_ONBOARDING_DETAILS,
        component: OnboardingDetail,
        permissions: [Admin],
        exact: true
    },
    {
        path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_ONBOARDING_UPDATE,
        component: UpdateOnboarding,
        permissions: [Admin],
        exact: true
    },

    //Notification Management
    {
        path: APP_ROUTES.NOTIFICATION_MANAGEMENT,
        component: NotificationManagement,
        permissions: [Admin],
        exact: true
    },

    {
        path: APP_ROUTES.NOTIFICATION_MANAGEMENT_ADD,
        component: AddNotification,
        permissions: [Admin],
        exact: false
    },

    {
        path: APP_ROUTES.NOTIFICATION_MANAGEMENT_DETAILS,
        component: NotificatioDetail,
        permissions: [Admin],
        exact: false
    },
    {
        path: APP_ROUTES.NOTIFICATION_MANAGEMENT_UPDATE,
        component: NotificatioUpdate,
        permissions: [Admin],
        exact: false
    },

    //Account

    {
        path: APP_ROUTES.ACCOUNT,
        component: Account,
        permissions: [Admin],
        exact: false
    },

    // Goals Managment
    {
        path: APP_ROUTES.GOAL_MANAGEMENT,
        component: GoalManagement,
        permissions: [Admin],
        exact: false
    },

    {
        path: APP_ROUTES.GOAL_MANAGEMENT_PRIMARY,
        component: GoalManagement,
        permissions: [Admin],
        exact: true
    },
    {
        path: APP_ROUTES.GOAL_MANAGEMENT_SECONDARY,
        component: GoalManagement,
        permissions: [Admin],
        exact: false
    },
    {
        path: APP_ROUTES.GOAL_PRIMARY_DETAIL,
        component: GoalDetails,
        permissions: [Admin],
        exact: false
    },
    {
        path: APP_ROUTES.GOAL_SECONDARY_DETAIL,
        component: GoalDetails,
        permissions: [Admin],
        exact: false
    },
    {
        path: APP_ROUTES.GOAL_MANAGEMENT_ADD,
        component: AddGoal,
        permissions: [Admin],
        exact: false
    },
    {
        path: APP_ROUTES.NARRATOR_ADD,
        component: AddNarrator,
        permissions: [Admin],
        exact: false
    },
    {
        path: APP_ROUTES.AUTHOR_ADD,
        component: AddAuthor,
        permissions: [Admin],
        exact: false
    },
    {
        path: APP_ROUTES.NARRATOR_EDIT,
        component: UpdateNarrator,
        permissions: [Admin],
        exact: false
    },
    {
        path: APP_ROUTES.AUTHOR_EDIT,
        component: UpdateAuthor,
        permissions: [Admin],
        exact: false
    },

    {
        path: APP_ROUTES.GOAL_MANAGEMENT_SECONDARY_EDIT,
        component: UpdateGoal,
        permissions: [Admin],
        exact: false
    },
    {
        path: APP_ROUTES.GOAL_MANAGEMENT_PRIMARY_EDIT,
        component: UpdateGoal,
        permissions: [Admin],
        exact: false
    },
    {
        path: APP_ROUTES.AUTHOR_AND_NARRATOR_MANAGEMENT,
        component: AuthorAndNarratorManagement,
        permissions: [Admin],
        exact: false
    },

    {
        path: APP_ROUTES.AUTHOR_MANAGEMENT,
        component: AuthorAndNarratorManagement,
        permissions: [Admin],
        exact: true
    },
    {
        path: APP_ROUTES.NARRATOR_MANAGEMENT,
        component: AuthorAndNarratorManagement,
        permissions: [Admin],
        exact: false
    },
    {
        path: APP_ROUTES.NARRATOR_DETAILS,
        component: NarratorDetails,
        permissions: [Admin],
        exact: false
    },
    {
        path: APP_ROUTES.AUTHOR_DETAILS,
        component: AuthorDetails,
        permissions: [Admin],
        exact: false
    }
];

export { authProtectedRoutes };
